import _ from 'underscore';

export default class ProductPriceGroup {
  constructor($scope, ProductService) {
    $scope.load_data = function() {
      $scope.loading = true;
      ProductService.get_price_group_members(window.price_group.id).then(function(response) {
        $scope.products = response.data.products;
        return ProductService.get_products_for_price_groups(window.price_group.product_group_id);
      }).then(function(data) {
        var diff = _.difference(_.pluck(data.products, 'id'), _.pluck($scope.products, 'id'));
        $scope.all_products = _.filter(data.products, function(p) {
          return diff.indexOf(p.id) >= 0;
        });
        $scope.selected_product = null;
        $scope.loading = false;
      });
    };

    $scope.add_product = function() {
      $scope.adding = true;
      ProductService.add_price_group_member(window.price_group.id, $scope.selected_product.id).success(function(data) {
        if (data.success) {
          $scope.load_data();
          $scope.adding = false;
        }
      });
    };

    $scope.remove_product = function(product) {
      ProductService.remove_price_group_member(window.price_group.id, product.id).success(function(data) {
        if (data.success)
          $scope.load_data();
      });
    };

    $scope.update_title = function() {
      $scope.updating = true;
      ProductService.update_price_group_title(window.price_group.id, $scope.updated_title).success(function(data) {
        if (data.success) {
          $scope.price_group.title = $scope.updated_title;
          $scope.updated_title = null;
          $scope.updating = false;
        }
      });
    };

    $scope.init = function() {
      $scope.price_group = window.price_group;
      $scope.load_data();
    };

    $scope.init();
  }
}

ProductPriceGroup.$inject = ['$scope', 'ProductService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/product-price-group.ctrl.js